// extracted by mini-css-extract-plugin
export default {"item":"BottomNavigationBar_item__IOW71","img":"BottomNavigationBar_img__vGoKE","imgActive":"BottomNavigationBar_imgActive__Q9h+-"};